import React from 'react';
import { Helmet } from 'react-helmet';

const SchemaOrg = ({ url, title, description, image, organization, datePublished, dateModified, author, type = 'WebPage' }) => {
  // Schéma de base pour toutes les pages
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': type,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    headline: title,
    description: description,
    image: image,
    url: url,
  };

  // Ajout des informations de date et d'auteur pour les articles
  if (type === 'Article' || type === 'BlogPosting') {
    baseSchema.datePublished = datePublished;
    baseSchema.dateModified = dateModified || datePublished;
    baseSchema.author = {
      '@type': 'Person',
      name: author,
    };
    baseSchema.publisher = organization;
  }

  // Schéma pour l'organisation
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Nexlyx',
    url: 'https://nexlyx.fr',
    logo: {
      '@type': 'ImageObject',
      url: 'https://nexlyx.fr/logo.png',
      width: 512,
      height: 512,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+33638988909',
      contactType: 'customer service',
      areaServed: 'FR',
      availableLanguage: ['French'],
    },
    sameAs: [
      'https://www.instagram.com/simon_lp04/',
      'https://www.linkedin.com/in/simon-leplat-ab933b273/'
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Route de Font Gamatte',
      addressLocality: 'Meyreuil',
      postalCode: '13590',
      addressCountry: 'FR',
    },
  };

  // Schéma pour le site web
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Nexlyx',
    url: 'https://nexlyx.fr',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://nexlyx.fr/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  // Schéma pour les services
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Développement Web',
    provider: {
      '@type': 'Organization',
      name: 'Nexlyx',
      url: 'https://nexlyx.fr',
    },
    areaServed: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: 43.4667,
        longitude: 5.5167,
      },
      geoRadius: '100000',
    },
    description: 'Création de sites web, refonte de sites existants, optimisation SEO et maintenance web.',
    offers: {
      '@type': 'Offer',
      price: '250',
      priceCurrency: 'EUR',
    },
  };

  // Schéma pour les breadcrumbs
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Accueil',
        item: 'https://Nexlyx.fr',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: title,
        item: url,
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(baseSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaOrg;
